import { ReactNode } from 'react';

import { BoxProps } from '@rbilabs/universal-components';

import { ISanityImage } from '@rbi-ctg/menu';
import { IImageFragment } from 'generated/sanity-graphql';
import { IUIContext } from 'state/ui';

export interface IPictureProps extends BoxProps {
  alt: string;
  children?: ReactNode;
  className?: string;
  image?: ISanityImage | IImageFragment | null;
  lazy?: boolean;
  lockedAspectRatio?: boolean;
  lqOff?: boolean;
  objectFitContain?: boolean;
  placeholderAspectRatio?: number;
  quality?: number;
  //draggable?: boolean; // TODO: RN

  // A number multiplier to be used when requesting the image.
  // Useful when you will need to zoom in on the image or the image will be artificial cropped.
  //
  // A value of 1 will keep the resolution the same.
  // Values less then 1 will decrease the resolution.
  // And values greater then one will increase resolution
  resolutionMultiplier?: number;

  // Flag to validate if we need to use height/width props
  sizedByChildren?: boolean;
  cache?: 'web' | 'immutable' | 'cacheOnly';
  priority?: 'high' | 'normal' | 'low';

  onImageLoaded?: () => void;
  buildImageUrl?: IUIContext['buildImageUrl'];
}

export enum ResizeMode {
  contain = 'contain',
  cover = 'cover',
}

export type IntrinsicBoundaryDimensions = {
  width: number;
  height: number;
  aspectRatio: number;
};

export type ExtrinsicBoundaryDimensions = {
  width?: string | number;
  height?: string | number;
};

export type MeasuredDimensions = {
  width: number;
  height: number;
};

export enum LoadState {
  'preload',
  'loading',
  'loaded',
}

export type ImageStyle = {
  width?: string | number;
  height?: string | number;
  opacity?: number;
};

export type ImageSource = {
  uri?: string | undefined;
  headers?:
    | {
        [key: string]: string;
      }
    | undefined;
  priority?: 'low' | 'normal' | 'high' | undefined;
  cache?: 'immutable' | 'web' | 'cacheOnly' | undefined;
};

export interface ISvgOrImageProps {
  isSVG: boolean;
  uri: NonNullable<ImageSource['uri']>;
  cache: NonNullable<ImageSource['cache']>;
  priority: NonNullable<ImageSource['priority']>;
  onLoad?: () => void;
  style: ImageStyle;
  accessibilityLabel?: string;
  resizeMode?: ResizeMode;
  preloadImage?: NonNullable<ImageSource['uri']>;
  children?: ReactNode;
}
